"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _HomeHeader = _interopRequireDefault(require("./HomeHeader")); // import app components


var BaseLayout = function BaseLayout(props) {
  var children = props.children;
  return /*#__PURE__*/_react.default.createElement(_antd.Layout, null, /*#__PURE__*/_react.default.createElement(_antd.Layout.Header, {
    style: {
      background: '#001529'
    }
  }, /*#__PURE__*/_react.default.createElement(_HomeHeader.default, null)), /*#__PURE__*/_react.default.createElement(_antd.Layout.Content, null, " ", children), /*#__PURE__*/_react.default.createElement(_antd.Layout.Footer, null));
};

var _default = BaseLayout;
exports.default = _default;